export default __webpack_public_path__ + "static/media/Intro-Card-2.1a7595b6.svg";